import { createAction } from "redux-act";

export const OpenSetTargetModalAction = createAction("Set Target - Open Modal");
export const CloseSetTargetModalAction = createAction("Set Target - Close Modal");
